import React from 'react'
import { useDeepCompareEffect } from '../useDeepCompareEffect'

export function useReactiveState<T>(value: T): [T, React.Dispatch<React.SetStateAction<T>>] {
  const [newValue, setNewValue] = React.useState<T>(value)

  useDeepCompareEffect(() => {
    setNewValue(value)
  }, [value])

  return [newValue, setNewValue]
}
